import { DataService } from "./data";
import { ObjectProfilePermission, PermissionFormData, CRMObject } from "@/types/crm/permissions";

export class CRMPermissionsService {
    /**
     * Récupérer la liste des objets configurables
     */
    static async getObjects(): Promise<CRMObject[]> {
        return DataService.client.get("/crm/app/objects/").json();
    }

    /**
     * Récupérer les permissions pour un objet spécifique
     */
    static async getPermissions(referenceTypeId: number): Promise<ObjectProfilePermission[]> {
        return DataService.client.get(`/crm/app/object-profile-permissions/by_reference_type/?reference_type_id=${referenceTypeId}`).json();
    }

    /**
     * Récupérer les permissions pour un profil spécifique
     */
    static async getPermissionsByProfile(profile: string): Promise<ObjectProfilePermission[]> {
        return DataService.client.get(`/crm/app/object-profile-permissions/by_profile/?profile=${profile}`).json();
    }

    /**
     * Créer une nouvelle permission
     */
    static async createPermission(data: PermissionFormData): Promise<ObjectProfilePermission> {
        return DataService.client.post(data, "/crm/app/object-profile-permissions/").json();
    }

    /**
     * Mettre à jour une permission existante
     */
    static async updatePermission(id: number, data: Partial<PermissionFormData>): Promise<ObjectProfilePermission> {
        return DataService.client.patch(data, `/crm/app/object-profile-permissions/${id}/`).json();
    }

    /**
     * Mettre à jour les champs d'une permission
     */
    static async updatePermissionFields(id: number, fields: string[]): Promise<ObjectProfilePermission> {
        return DataService.client.patch({ fields }, `/crm/app/object-profile-permissions/${id}/`).json();
    }

    /**
     * Supprimer une permission
     */
    static async deletePermission(id: number): Promise<void> {
        return DataService.client.delete(`/crm/app/object-profile-permissions/${id}/`).json();
    }

    /**
     * Récupérer une permission spécifique
     */
    static async getPermission(id: number): Promise<ObjectProfilePermission> {
        return DataService.client.get(`/crm/app/object-profile-permissions/${id}/`).json();
    }

    /**
     * Mettre à jour ou créer une permission pour un profil
     */
    static async updateOrCreatePermission(referenceTypeId: number, profile: string, data: Partial<PermissionFormData>): Promise<ObjectProfilePermission> {
        return DataService.client
            .post(
                {
                    reference_type: referenceTypeId,
                    profile: profile,
                    ...data
                },
                "/crm/app/object-profile-permissions/update_or_create/"
            )
            .json();
    }
}
